<div class="d-flex flex-column align-items-center mb-md-5">
  <h4 class="text-center text-uppercase accessory-title elsa-title-font">{{'label_accessory' | translate}}</h4>
  <h3 class="text-center text-uppercase accessory-name elsa-title-font">{{title}}</h3>
  <ng-container *ngIf="img">
    <picture>
      <img class="accessory-img object-fit-cover" [src]="img" [alt]="title">
    </picture>
  </ng-container>
  <span class="text-uppercase accessory-code font-weight-bold">{{code}}</span>
  <div class="accessory-description ellipsized-description five-lines-text font-weight-light" *ngIf="description">{{description}}</div>

  <a [title]="title" appEmptyTitle class="btn btn-gray text-white btn-elsa text-uppercase"
     (click)="openQuotation()">{{'label_info' | translate}}</a>
</div>
